import {
  GameConfig,
  GameResponse,
  GameEntitlementResponse,
} from '@models/game-config.interface';
import { EconomyResponse, InventoryResponse } from '@models/economy';
import { PlayResponse } from '@models/play-response';
import { SessionParams } from '@models/session-params';
import { Api } from '@services/api/api.interface';
import { Singleton } from '@utils/singleton';

@Singleton
export class MockApiService implements Api {
  private _position = 0;
  private _stepSequence = [5, 5, 2, 6];
  private _stepIndex = 0;

  setToken(_token?: string): void {}

  async fetchGameLabels(
    _url: string,
    _fallbackUrl: string,
  ): Promise<Record<string, string>> {
    return Promise.resolve({} as Record<string, string>);
  }

  async fetchGameConfig(
    _url: string,
    _fallbackUrl: string,
  ): Promise<GameConfig> {
    return Promise.resolve({} as GameConfig);
  }

  async fetchGameConfigUrl(_params: SessionParams): Promise<GameResponse> {
    return Promise.resolve({
      gameConfigUrl: '',
      startPosition: { tile: 0 },
    } as GameResponse);
  }

  async play(): Promise<PlayResponse> {
    console.log('[Mock API] Play game');
    // fake delay
    await new Promise((resolve) => setTimeout(resolve, 1000));
    const steps = this._stepSequence[this._stepIndex];
    this._stepIndex = (this._stepIndex + 1) % this._stepSequence.length;

    this._position = this._position + steps;

    return {
      rollsAvailable: 5,
      nextRoll: 0, // in 10 min
      actions: [],
    };
  }

  async resetStage(): Promise<void> {
    console.log('[Mock API] resetStage');
    this._position = 0;
    this._stepIndex = 0;
  }

  async fetchInventory(): Promise<InventoryResponse> {
    return Promise.resolve({
      playerId: '',
      gameId: '',
      items: [],
    });
  }

  async fetchEconomy(): Promise<EconomyResponse> {
    return Promise.resolve({
      coins: 0,
      prizes: [],
      xp: 0,
    });
  }

  async fetchGameState(_gameUuid: string): Promise<GameEntitlementResponse> {
    return Promise.resolve({} as GameEntitlementResponse);
  }
}
